import type {
  PhaseDurationOperator,
  PhaseNameOperator
} from 'Automations/nodeDefinitions/conditions/helpers/functionStrings/phase'

export const PHASE_OPERATOR_KEYS = ['NAME', 'DURATION'] as const
export type PhaseOperator = (typeof PHASE_OPERATOR_KEYS)[number]

export const PHASE_OPERATOR_LABELS: Record<PhaseOperator, string> = {
  NAME: 'Name',
  DURATION: 'Duration'
}

export const PHASE_NAME_OPERATOR_LABELS: Record<PhaseNameOperator, string> = {
  IS_EQUAL: 'Equals',
  IS_NOT_EQUAL: 'Does not equal',
  INCLUDES: 'Includes',
  EXCLUDES: 'Excludes',
  NOT_SET: 'Not set'
}

export const PHASE_DURATION_OPERATOR_LABELS: Record<
  PhaseDurationOperator,
  string
> = {
  SHORTER_THAN: 'Shorter than',
  LONGER_THAN: 'Longer than',
  EQUALS: 'Equals',
  DOES_NOT_EQUAL: 'Does not equal',
  IS_OPEN_ENDED: 'Is open ended'
}

// Conflicts stay within one sub-property, so Name and Duration combine freely.
// ADR: https://app.notion.com/p/sequencehq/Approval-conditions-Phase-3ed9b9b6e5c68012bebdd1a37d71a37f
export const PHASE_NAME_OPERATOR_CONFLICTS: Record<
  PhaseNameOperator,
  ReadonlyArray<PhaseNameOperator>
> = {
  IS_EQUAL: ['IS_EQUAL', 'IS_NOT_EQUAL', 'INCLUDES', 'EXCLUDES', 'NOT_SET'],
  IS_NOT_EQUAL: ['IS_EQUAL', 'IS_NOT_EQUAL', 'INCLUDES', 'EXCLUDES', 'NOT_SET'],
  INCLUDES: ['IS_EQUAL', 'IS_NOT_EQUAL', 'INCLUDES', 'NOT_SET'],
  EXCLUDES: ['IS_EQUAL', 'IS_NOT_EQUAL', 'EXCLUDES', 'NOT_SET'],
  NOT_SET: ['IS_EQUAL', 'IS_NOT_EQUAL', 'INCLUDES', 'EXCLUDES', 'NOT_SET']
}

export const PHASE_DURATION_OPERATOR_CONFLICTS: Record<
  PhaseDurationOperator,
  ReadonlyArray<PhaseDurationOperator>
> = {
  SHORTER_THAN: ['SHORTER_THAN', 'EQUALS', 'DOES_NOT_EQUAL', 'IS_OPEN_ENDED'],
  LONGER_THAN: ['LONGER_THAN', 'EQUALS', 'DOES_NOT_EQUAL', 'IS_OPEN_ENDED'],
  EQUALS: [
    'SHORTER_THAN',
    'LONGER_THAN',
    'EQUALS',
    'DOES_NOT_EQUAL',
    'IS_OPEN_ENDED'
  ],
  DOES_NOT_EQUAL: [
    'SHORTER_THAN',
    'LONGER_THAN',
    'EQUALS',
    'DOES_NOT_EQUAL',
    'IS_OPEN_ENDED'
  ],
  IS_OPEN_ENDED: [
    'SHORTER_THAN',
    'LONGER_THAN',
    'EQUALS',
    'DOES_NOT_EQUAL',
    'IS_OPEN_ENDED'
  ]
}
